import React, { useContext, useEffect, useState } from "react";
import { Menu, type MenuProps, theme } from "antd";
import Sider from "antd/es/layout/Sider";
import { useNavigate, useLocation } from "react-router-dom";
import { TbPokeball } from "react-icons/tb";
import {
    TrophyOutlined,
    SkinOutlined,
    UserOutlined,
    TeamOutlined,
    CompassOutlined,
    GiftOutlined,
    HistoryOutlined
} from "@ant-design/icons";
import { AuthContext } from "../../../config/AuthContext";

interface Props {
    setTabKey?: (key: string) => void;
}

export const JAVAMON_MENU_ITEMS: {
    key: string;
    slug: string;
    name: string;
    icon: React.ReactNode;
    url: string;
}[] = [
    { key: '1', slug: 'javamons', name: 'Javamons', icon: <TbPokeball style={{ fontSize: 16 }} />, url: '/jutge/javamon/config/javamons' },
    { key: '4', slug: 'trofeos', name: 'Trofeos', icon: <TrophyOutlined />, url: '/jutge/javamon/config/trofeos' },
    { key: '5', slug: 'skins', name: 'Configuración Skins', icon: <SkinOutlined />, url: '/jutge/javamon/config/skins' },
    { key: '6', slug: 'avatares', name: 'Avatares', icon: <UserOutlined />, url: '/jutge/javamon/config/avatares' },
    { key: '7', slug: 'equipment', name: 'Equipamiento de Usuarios', icon: <TeamOutlined />, url: '/jutge/javamon/config/equipment' },
    { key: '8', slug: 'scenes', name: 'Mapas y Actividades', icon: <CompassOutlined />, url: '/jutge/javamon/config/scenes' },
    { key: '9', slug: 'botines', name: 'Botines', icon: <GiftOutlined />, url: '/jutge/javamon/config/botines' },
    { key: '10', slug: 'historial', name: 'Historial de recompensas', icon: <HistoryOutlined />, url: '/jutge/javamon/config/historial' }
];

const AppSiderJavamons: React.FC<Props> = ({ setTabKey }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setBreadCrumb } = useContext(AuthContext);

    // Determinar la opción seleccionada según la URL
    const getActiveKeyFromPath = () => {
        const path = location.pathname.toLowerCase();
        for (const item of JAVAMON_MENU_ITEMS) {
            if (path.endsWith('/' + item.slug) || path.includes('/' + item.slug)) {
                return item.key;
            }
        }
        return '1'; // Javamons por defecto
    };

    const activeKey = getActiveKeyFromPath();

    const items: MenuProps['items'] = JAVAMON_MENU_ITEMS.map((item) => ({
        key: item.key,
        icon: item.icon,
        label: item.name,
        onClick: () => {
            if (setTabKey) setTabKey(item.key);
            navigate(item.url);
        }
    }));

    const {
        token: { colorBgContainer },
    } = theme.useToken();

    return (
        <Sider style={{ background: colorBgContainer }} width={230}>
            <div style={{
                padding: '16px 20px 12px 20px',
                borderBottom: '1px solid #f0f0f0',
                display: 'flex',
                alignItems: 'center',
                gap: 10
            }}>
                <TbPokeball style={{ fontSize: 22, color: '#ff4d4f' }} />
                <span style={{ fontWeight: 'bold', fontSize: 16, color: '#262626' }}>Javamons</span>
            </div>
            <Menu
                mode="inline"
                selectedKeys={[activeKey]}
                style={{ height: 'calc(100% - 53px)', borderRight: 0 }}
                items={items}
            />
        </Sider>
    );
};

export default AppSiderJavamons;
